import { all, call, put, retry, select, takeLatest } from 'redux-saga/effects';
import { streamsActions, streamsSelector } from '$store/streams';
import { FetchMessagesAction, SendMessageAction } from './interface';
import { Api } from '$api';
import { batchActions } from '$store';
import { toastActions } from '$store/toast';

function* fetchMessagesWorker(action: FetchMessagesAction) {
  try {
    const { messages } = yield select(streamsSelector);

    const data = yield retry(
      Infinity,
      3000,
      Api.post,
      `/streaming/im/${action.payload.streamId}/history`,
      { startFrom: messages.length },
    );

    yield put(
      batchActions(
        streamsActions.setMessages([...messages, ...data.messages]),
        streamsActions.setViewers(data.online),
        streamsActions.setIsFinished(data.stream.streamStatus === 'finished'),
      ),
    );
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

function* sendMessageWorker(action: SendMessageAction) {
  try {
    yield call(Api.post, `/streaming/im/${action.payload.streamId}/send`, {
      text: action.payload.text,
    });

    yield put(streamsActions.setChatFormText(''));
    yield put(streamsActions.fetchMessages({ streamId: action.payload.streamId }));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  } finally {
    yield put(streamsActions.setIsSendingMessage(false));
  }
}

export function* streamsSaga() {
  yield all([
    takeLatest(streamsActions.fetchMessages, fetchMessagesWorker),
    takeLatest(streamsActions.sendMessage, sendMessageWorker),
  ]);
}
